module.exports = WebFont;